<script>
    import SubDivisions from "../data/SubDivision"
    import { api} from "../../store"

    let  api_url
    api.subscribe(value => (api_url = value))

    let search = {
        gender: "Male",
        sub_caste: "",
        country: "",

    }

    let results = []
    let limit = 2
    let skip = 0

    $:search? getResult() :null

    function getResult() {

        let query = new FormData()
        query.append("search", "true")

        search.gender !=""? query.append("gender", search.gender): null
        search.sub_caste !=""? query.append("sub_caste", search.sub_caste): null
        search.country !=""? query.append("country", search.country): null

        fetch(`${api_url}matrimonial.php`, {
        method: "POST",
        body: query 
    })
    .then(res => res.json())
    .then(res => {
        results = [...res.data]
    })
    

    }

</script>

<div class="ds-form-title text-center p-5" style="margin-top: 10vh;">
    <h1>Matrimonial Search </h1>

 </div>
<div class="searchBar">
    <div>
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label>Gender</label>
        <select bind:value={search.gender}>
            <option value={"Male"}>Male</option>
            <option value={"Female"}>Female</option>
        </select>
    </div>
    <div>
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label>Sub Division</label>
        <select bind:value={search.sub_caste}>
            <option value="">Select Sub Division</option>
            {#each SubDivisions as Divisions}
            <option value={Divisions}>{Divisions}</option>
            {/each}
        </select>
    </div>
    <div>
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label>Country (Current)</label>
        <select bind:value={search.country}>
            <option value="">Select Country</option>
            <option value={"India"}>India</option>
            <option value={"US"}>US</option>
        </select>
    </div>
</div>

{#if Array.isArray(results) && results.length > 0 }

<table class="table">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Name</th>
        {#if window.screen.width> 900}
        <th scope="col">Education</th>
        <th scope="col">Working</th>
        {/if}
        
        <th scope="col">Action</th>
      </tr>
    </thead>
    <tbody>
        {#each [...results].splice(skip,limit) as result, index}
        <tr>
            <th scope="row">{index+1}</th>
            <td>{result.full_name}</td>
            {#if window.screen.width > 900}
                <td>{result.education}</td>
                <td>{result.working}</td>
            {/if}
            
            <td><a href={`/viewmatrimonialdetails?id=${result.id}`} class="btn btn-primary">View</a></td>
        </tr>
        {/each}
    </tbody>
  </table>

{:else}
<div>
    <h2 class="text-center p-5">No Results</h2>
</div>
{/if}

<div class="ds-pagination">
    <nav aria-label="Page navigation example">
        <ul class="pagination">
          
          {#if Array.isArray(results) && results.length > 0}
          {#if skip>0}
          <li class="page-item"><button on:click={()=>{skip -= limit}} class="page-link">Previous</button></li>
          {/if}
          {#each Array(Math.ceil(results.length/limit)) as arys, index}
            <li class="page-item">
                <button 
                on:click={()=>{skip = limit*index}}
                class="page-link">
                    {index+1}
                </button>
            </li>
          {/each}
          {#if results.length > skip+limit}
          <li class="page-item">
            <button on:click={()=>{skip += limit}} class="page-link">Next</button>
          </li>
          {/if}
          
          {/if}
      
          
        </ul>
      </nav>
</div>

<style lang="scss">
    @import "../scss/Config.scss";
    .searchBar {
        width: 80%;
        background-color: #fff;
        margin: auto;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        box-shadow: 10px 10px 50px rgba(0, 0, 0, 0.1);
        transition: box-shadow ease 0.3s;
        

        &:hover {
            box-shadow: 0 0 50px rgba(0, 0, 0, 0.2);
        }

        div {
            display: flex;
            flex-direction: column;
            padding: 5%;
        }

        @include mobile {
            grid-template-columns: 1fr ;
            div {
                display: flex;
                flex-direction: column;
                padding: 2%;

                select {
                    width: 100%;
                }
            }
        }
    }

    .table {
        width: 80%;
        background-color: #fff;
        margin: auto;
        padding: 5%;
        margin-top: 2%;
    }

    .ds-pagination{
        width: 80%;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2.5%;
    }
</style>